const TUI_CHINESE_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['号码', '信用卡号码'],
  cardExpiry: ['有效期', '信用卡有效期']
};
const TUI_CHINESE_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['纯色', '渐变色'],
  toolbarTools: {
    undo: '撤消',
    redo: '重做',
    font: '字体',
    fontStyle: '字体样式',
    fontSize: '字体大小',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    strikeThrough: '删除线',
    justify: '对齐',
    justifyLeft: '左对齐',
    justifyCenter: '中心对齐',
    justifyRight: '右对齐',
    justifyFull: '两端对齐',
    list: '列表',
    indent: '缩进',
    outdent: '减小缩进',
    unorderedList: '无序列表',
    orderedList: '有序列表',
    quote: '引用',
    foreColor: '颜色',
    backColor: '背景颜色',
    hiliteColor: '高亮颜色',
    clear: '清除',
    link: '链接',
    attach: '附加文件',
    tex: '插入 TeX',
    code: '代码',
    image: '插入图片',
    insertHorizontalRule: '插入水平线',
    superscript: '上标',
    subscript: '下标',
    insertTable: '插入表格',
    insertGroup: 'Insert group',
    hiliteGroup: 'Hilite group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: '合并单元格',
    splitCells: '拆分单元格',
    rowsColumnsManaging: '管理行和列',
    cellColor: '单元格颜色',
    setDetails: '详细信息',
    removeDetails: '删除详细信息'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['在前面插入列', '在后面插入列'], ['在前面插入行', '在后面插入行'], ['删除列', '删除行']],
  editorCodeOptions: ['文中代码', '代码块'],
  editorFontOptions: {
    small: '小的',
    large: '大的',
    normal: '普通的',
    title: '标题',
    subtitle: '副标题'
  }
};
const TUI_CHINESE_LANGUAGE_ADDON_TABLE = {
  showHideText: '显示/隐藏',
  paginationTexts: {
    pages: '页面',
    linesPerPage: '每页行数',
    of: '于'
  }
};
const TUI_CHINESE_LANGUAGE_COUNTRIES = {
  AD: '安道尔',
  AE: '阿拉伯联合酋长国',
  AF: '阿富汗',
  AG: '安提瓜和巴布达',
  AI: '安圭拉',
  AL: '阿尔巴尼亚',
  AM: '亚美尼亚',
  AO: '安哥拉',
  AR: '阿根廷',
  AT: '奥地利',
  AU: '澳大利亚',
  AW: '阿鲁巴',
  AZ: '阿塞拜疆',
  BA: '波斯尼亚和黑塞哥维那',
  BB: '巴巴多斯',
  BD: '孟加拉国',
  BE: '比利时',
  BF: '布基纳法索',
  BG: '保加利亚',
  BH: '巴林',
  BI: '布隆迪',
  BJ: '贝宁',
  BL: '圣巴泰勒米岛',
  BM: '百慕大',
  BN: '文莱达鲁萨兰国',
  BO: '玻利维亚',
  BQ: '荷属加勒比区',
  BR: '巴西',
  BS: '巴哈马',
  BT: '不丹',
  BW: '博茨瓦纳',
  BY: '白罗斯',
  BZ: '伯利兹',
  CA: '加拿大',
  CD: '刚果民主共和國',
  CF: '中非共和国',
  CG: '刚果（布拉柴维尔）',
  CH: '瑞士',
  CI: '科特迪瓦',
  CL: '智利',
  CM: '喀麦隆',
  CN: '中国',
  CO: '哥伦比亚',
  CR: '哥斯达黎加',
  CU: '古巴',
  CV: '佛得角',
  CW: '库拉索岛',
  CY: '塞浦路斯',
  CZ: '捷克共和国',
  DE: '德国',
  DJ: '吉布提',
  DK: '丹麦',
  DM: '多米尼克',
  DO: '多米尼加共和国',
  DZ: '阿尔及利亚',
  EC: '厄瓜多尔',
  EE: '爱沙尼亚',
  EG: '埃及',
  ER: '厄立特里亚',
  ES: '西班牙',
  ET: '埃塞俄比亚',
  FI: '芬兰',
  FJ: '斐济',
  FK: '福克兰群岛',
  FM: '密克罗尼西亚联邦',
  FR: '法国',
  GA: '加蓬',
  GB: '英国',
  GD: '格林纳达',
  GE: '圭亚那',
  GF: '格鲁吉亚',
  GH: '加纳',
  GI: '直布罗陀',
  GL: '格陵兰',
  GM: '冈比亚',
  GN: '瓜德罗普岛',
  GP: '几内亚',
  GQ: '赤道几内亚',
  GR: '希腊',
  GT: '危地马拉',
  GW: '几内亚比绍',
  GY: '圭亚那',
  HK: '中国香港特别行政区',
  HN: '洪都拉斯',
  HR: '克罗地亚',
  HT: '海地',
  HU: '匈牙利',
  ID: '印度尼西亚',
  IE: '爱尔兰',
  IL: '以色列',
  IN: '印度',
  IQ: '伊拉克',
  IR: '伊朗',
  IS: '冰岛',
  IT: '意大利',
  JM: '牙买加',
  JO: '约旦',
  JP: '日本',
  KE: '肯尼亚',
  KG: '吉尔吉斯斯坦',
  KH: '柬埔寨',
  KM: '科摩罗',
  KN: '圣基茨和尼维斯',
  KP: '朝鲜',
  KR: '韩国',
  KW: '科威特',
  KY: '开曼群岛',
  KZ: '哈萨克斯坦',
  LA: '老挝',
  LB: '黎巴嫩',
  LC: '圣卢西亚',
  LI: '列支敦士登',
  LK: '斯里兰卡',
  LR: '利比里亚',
  LS: '莱索托',
  LT: '立陶宛',
  LU: '卢森堡',
  LV: '拉脱维亚',
  LY: '利比亚',
  MA: '摩洛哥',
  MC: '摩纳哥',
  MD: '摩尔多瓦',
  ME: '圣马丁',
  MF: '黑山',
  MG: '马达加斯加',
  MK: '北马其顿共和国',
  ML: '马里',
  MM: '缅甸',
  MN: '蒙古',
  MO: '马提尼克岛',
  MQ: '中国.澳门',
  MR: '毛里塔尼亚',
  MS: '蒙特塞拉特',
  MT: '马耳他',
  MU: '毛里求斯',
  MV: '马尔代夫',
  MW: '马拉维',
  MX: '墨西哥',
  MY: '马来西亚',
  MZ: '莫桑比克',
  NA: '纳米比亚',
  NC: '新喀里多尼亞',
  NE: '尼日尔',
  NG: '尼日利亚',
  NI: '尼加拉瓜',
  NL: '荷兰',
  NO: '挪威',
  NP: '尼泊尔',
  NZ: '新西兰',
  OM: '阿曼',
  PA: '巴拿马',
  PE: '秘鲁',
  PF: '法属波利尼西亚（大溪地）',
  PG: '巴布亚新几内亚',
  PH: '菲律宾',
  PK: '巴基斯坦',
  PL: '波兰',
  PT: '葡萄牙',
  PW: '帕劳',
  PY: '巴拉圭',
  QA: '会议',
  RE: '卡塔尔',
  RO: '罗马尼亚',
  RS: '塞尔维亚',
  RU: '俄罗斯',
  RW: '卢旺达',
  SA: '沙特阿拉伯',
  SB: '所罗门群岛',
  SC: '塞舌尔',
  SD: '苏丹',
  SE: '瑞典',
  SG: '新加坡',
  SH: '圣赫勒拿',
  SI: '斯洛文尼亚',
  SK: '斯洛伐克',
  SL: '塞拉利昂',
  SM: '圣马力诺',
  SN: '塞内加尔',
  SO: '索马里',
  SR: '苏里南',
  ST: '圣多美和普林西比',
  SV: '萨尔瓦多',
  SX: '圣马丁',
  SY: '阿拉伯叙利亚共和国',
  SZ: '斯威士兰',
  TC: '特克斯和凯科斯群岛',
  TD: '乍得',
  TG: '多哥',
  TH: '泰国',
  TJ: '塔吉克斯坦',
  TL: '东帝汶',
  TM: '土库曼斯坦',
  TN: '突尼斯',
  TO: '汤加',
  TR: '土耳其',
  TT: '特立尼达和多巴哥',
  TW: '台湾',
  TZ: '坦桑尼亚',
  UA: '乌克兰',
  UG: '乌干达',
  US: '美国',
  UY: '乌拉圭',
  UZ: '乌兹别克斯坦',
  VC: '圣文森特和格林纳丁斯',
  VE: '委内瑞拉',
  VG: '英属维尔京群岛',
  VN: '越南',
  VU: '瓦努阿图',
  WS: '萨摩亚',
  XK: '科索沃',
  YE: '也门',
  YT: '马约特岛',
  ZA: '南非',
  ZM: '赞比亚',
  ZW: '津巴布韦',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_CHINESE_LANGUAGE_CORE = {
  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  close: '关闭',
  clear: '清除',
  nothingFoundMessage: '什么都没找到',
  defaultErrorMessage: '无效值',
  spinTexts: ['前', '后'],
  shortWeekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  countries: TUI_CHINESE_LANGUAGE_COUNTRIES
};
const TUI_CHINESE_LANGUAGE_KIT = {
  cancel: '撤消',
  done: '完成',
  more: '更多',
  otherDate: '其他日期...',
  showAll: '显示所有',
  hide: '隐藏',
  mobileCalendarTexts: ['选择日期', '选择范围', '選擇日期'],
  range: ['从', '至'],
  countTexts: ['加', '减'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['显示密码', '隐藏密码'],
  copyTexts: ['复制', '已复制'],
  shortCalendarMonths: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  pagination: ['上一页', '下一页'],
  fileTexts: {
    loadingError: '加载错误',
    preview: '预览',
    remove: '清除'
  },
  inputFileTexts: {
    defaultLabelSingle: '或拖动\u00A0它\u00A0这里',
    defaultLabelMultiple: '或拖动\u00A0它们\u00A0这里',
    defaultLinkSingle: '选择一个文件',
    defaultLinkMultiple: '选择多个文件',
    maxSizeRejectionReason: '文件超出大小',
    formatRejectionReason: '文件格式错误',
    drop: '把文件放在这里',
    dropMultiple: '把多个文件放在这里'
  },
  multiSelectTexts: {
    all: '全选',
    none: '选择无'
  },
  confirm: {
    yes: '是',
    no: '不'
  },
  previewTexts: {
    rotate: '旋转'
  },
  zoomTexts: {
    zoomOut: '缩小',
    zoomIn: '放大',
    reset: '重置'
  },
  phoneSearch: '輸入國家或代碼'
};
const TUI_CHINESE_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_CHINESE_LANGUAGE = {
  name: 'chinese',
  ...TUI_CHINESE_LANGUAGE_CORE,
  ...TUI_CHINESE_LANGUAGE_KIT,
  ...TUI_CHINESE_LANGUAGE_ADDON_TABLE,
  ...TUI_CHINESE_LANGUAGE_ADDON_COMMERCE,
  ...TUI_CHINESE_LANGUAGE_ADDON_EDITOR,
  ...TUI_CHINESE_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_CHINESE_LANGUAGE, TUI_CHINESE_LANGUAGE_ADDON_COMMERCE, TUI_CHINESE_LANGUAGE_ADDON_EDITOR, TUI_CHINESE_LANGUAGE_ADDON_TABLE, TUI_CHINESE_LANGUAGE_CORE, TUI_CHINESE_LANGUAGE_COUNTRIES, TUI_CHINESE_LANGUAGE_KIT, TUI_CHINESE_LANGUAGE_LAYOUT };
